import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import logo from "../../../assets/img/svg/LogoRioTintoWhite.svg";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { Badge } from "@mui/material";
import { getNotificationsSelector } from "../../../store/alert/selectors";
import { useDispatch, useSelector } from 'react-redux';
import { useMsal } from "@azure/msal-react";
import { SetRoleClaims } from '../../../store/auth/actions';
import { getRoleClaimsSelector } from "../../../store/auth/selectors";
import AppConfig from "../../../config/AppConfig";
import { resetWorkflow } from '../../../store/dataProvisioningWorkflow/actions';
import { useNavigate } from "react-router-dom";
import { postConnectionReset } from "../../../store/dataSource/actions";
import { fetchTaskConnectionReset, postTaskConnectionReset } from "../../../store/eventBasedTrigger/actions";
import { deleteSubscriptionReset, fetchSubscriptionReset, postSubscriptionReset } from "../../../store/subscriptions/actions";
import { fetchTargetDetailsReset } from "../../../store/dataTarget/actions";

const settings = [
    "Switch Admin Mode",
    "Subscriptions", 
    "Approvals",
    "Logout"
];

const prodSettings = [
    "Subscriptions", 
    "Approvals",
    "Logout"
];

const env = AppConfig().environment;

interface OwnProps {
    toggleNavigationPane: (() => void) | ((event: React.KeyboardEvent | React.MouseEvent) => void);
    toggleNotifications: (() => void) | ((event: React.KeyboardEvent | React.MouseEvent) => void);
}

const AppHeader = (props: OwnProps) => {

    const { toggleNavigationPane, toggleNotifications } = props;
    const { instance, accounts } = useMsal();
    const navigate = useNavigate();

    const notifList = useSelector(getNotificationsSelector);

    const dispatch = useDispatch();

    //sets the value to open and close the menu
    const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
    const [notifCount, setNotifCount] = useState(0);
    //const [isAdmin, setIsAdmin] = useState(true);

    // roles  - IDP.Admin or IDP.User
    const roles: string[] = useSelector(getRoleClaimsSelector);  

    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = (setting: string) => {
        if (setting==="Logout") {
            instance.logout();
        } 

        if (setting==="Switch Admin Mode") {
            dispatch(SetRoleClaims(roles.includes("IDP.Admin") ? ['IDP.User'] : ['IDP.Admin','IDP.User']));
        }

        if (setting==="Subscriptions") {
            navigate("/subscriptions")
        }

        
        if (setting==="Approvals") {
            navigate("/MyApprovals")
        }

        setAnchorElUser(null);
    };

    const handleOpenHelpUrl = () => {
        window.open('https://riotinto.sharepoint.com/sites/6002415', '_blank', 'noopener,noreferrer')
    }
    const goHome = () =>{
        dispatch(resetWorkflow())
        dispatch(fetchTargetDetailsReset())
        dispatch(postConnectionReset());
        dispatch(postTaskConnectionReset());
        dispatch(fetchTaskConnectionReset());
        dispatch(postSubscriptionReset());
        dispatch(fetchSubscriptionReset())
        dispatch(deleteSubscriptionReset())
        navigate(`/`);
    }

    useEffect(() => {
        let count = notifList.length;
        setNotifCount(count);
    }, [notifList])

    return (
        <AppBar
            position="fixed"
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
            <Toolbar>
                <IconButton id="bb40f493-8f34-4057-a143-c9192e2122cc" style={{ left: -15 }} onClick={toggleNavigationPane}>
                    <MenuIcon style={{ color: "white" }} />
                </IconButton>
                <Box sx={{ flex: 1, display: { xs: "flex", md: "flex" } }} onClick={goHome}>
                    {/* <Link to="/" className="App-link"> */}
                        <img src={logo} alt="Rio Tinto" style={{cursor:"pointer"}} />
                    {/* </Link> */}
                </Box>

                <Box sx={{ flexGrow: 7, display: { xs: "flex", md: "flex" }, "paddingLeft": "35px"}}>
                    Unity Data Lake
                </Box>

                <Box sx={{ flexGrow: 0, display: { xs: "flex", md: "flex" } }}>
                    <Tooltip title="Open settings">
                        <IconButton id="3d5a9811-473e-4f59-aea9-f642f90ef12e" onClick={handleOpenUserMenu}>
                            <span style={{ color: "white", padding: "0 10px" }}>
                                {accounts[0]?.name?.replace(",", "")}
                            </span>
                            <AccountCircleIcon
                                className="IconStyle"
                                style={{ color: "white" }}
                            />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Help">
                        <IconButton id="1d46bf96-0f31-47e4-bf45-a2d580b5c3b7" onClick={handleOpenHelpUrl}>
                            <HelpOutlineIcon
                                className="IconStyle"
                                style={{ color: "white" }}
                            />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Notification">
                        <IconButton id="3bdcaea2-dacc-4cd9-9f85-71af5f954fbd" onClick={toggleNotifications}>
                            <Badge badgeContent={notifCount} color="secondary">
                                <NotificationsNoneIcon
                                    className="IconStyle"
                                    style={{ color: "white" }}
                                />
                            </Badge>
                        </IconButton>
                    </Tooltip>
                    <Menu
                        sx={{ mt: "45px" }}
                        id="menu-appbar"
                        anchorEl={anchorElUser}
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        open={Boolean(anchorElUser)}
                        onClose={handleCloseUserMenu}
                    >
                        {env==="production" ? prodSettings.map((setting) => (
                            <MenuItem key={setting} onClick={(e) => handleCloseUserMenu(setting)}>
                                <Typography textAlign="center">{setting}</Typography>
                            </MenuItem>
                        ))
                        :
                        settings.map((setting) => (
                            <MenuItem key={setting} onClick={(e) => handleCloseUserMenu(setting)}>
                                <Typography textAlign="center">{setting}</Typography>
                            </MenuItem>
                        ))
                    
                    }
                    </Menu>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default AppHeader;
